export default __webpack_public_path__ + "static/media/ic_search.e0fdbb8f.svg";